import styles from "./SoldOut.module.css"

export const soldOutSizes = ["sm", "lg"]

export type SoldOutProps = {
  size?: (typeof soldOutSizes)[number]
  unavailable?: boolean
}

export const SoldOut = ({
  size = "lg",
  unavailable = false,
}: SoldOutProps) => {
  return (
    <span
      className={`${styles.soldOut} ${
        size === "sm" ? "body-md-strong" : "title-md"
      }`}
    >
      <div className={styles.soldOutDot} data-unavailable={unavailable} />
      <span className={styles.soldOutText}>
        {unavailable ? "NOT AVAILABLE" : "SOLD OUT"}
      </span>
    </span>
  )
}
